import type { UserProfile, UserProfileView } from './types';

export function unwrapUserProfile(response: unknown): UserProfile {
  if (response && typeof response === 'object' && 'data' in response) {
    const envelope = response as { data?: UserProfile };
    if (envelope.data && typeof envelope.data === 'object') {
      return envelope.data;
    }
  }
  return response as UserProfile;
}

export function toUserProfileView(
  profile: UserProfile | null,
  fallback?: {
    id?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    fullName?: string;
    avatar?: string;
    phone?: string;
  } | null,
): UserProfileView {
  const fromNames = [profile?.firstName, profile?.lastName]
    .filter(Boolean)
    .join(' ')
    .trim();
  const fallbackName =
    fallback?.fullName ||
    `${fallback?.firstName || ''} ${fallback?.lastName || ''}`.trim();

  return {
    id: profile?.id != null ? String(profile.id) : String(fallback?.id || ''),
    displayName: profile?.name || fromNames || fallbackName || '',
    avatarUrl: profile?.imageUrl || fallback?.avatar || '',
    email: profile?.email || fallback?.email || '',
    phone: profile?.phone || fallback?.phone || '',
    gender: profile?.gender ?? null,
  };
}
